import React from 'react';
import './Stats.css';

const highlightMetrics = [
  { label: 'Students served', value: '350+', detail: 'across 12 states' },
  { label: 'Chapters active', value: '9', detail: 'with 4 more launching' },
  { label: 'Mentors onboarded', value: '180+', detail: 'trained in 2024' },
];

const insights = [
  {
    title: 'Community snapshot',
    bullets: [
      '40% of mentees are first-generation college students',
      'Students represent 35 home languages and 90+ high schools',
      '60% now feel confident applying to out-of-state programs',
    ],
  },
  {
    title: 'Program delivery',
    bullets: [
      'Every mentee attends at least 4 mentor-led studio sessions',
      'Curriculum spans storytelling, financial aid, and mock interviews',
      'Chapter teams log 1,500+ volunteer hours each semester',
    ],
  },
];

const menteeStats = [
  { value: '93%', detail: 'Would recommend Project LTF' },
  { value: '95%', detail: 'Felt their mentor pairing fit their goals' },
  { value: '90%', detail: 'Report overall satisfaction' },
];

const Numbers = () => (
  <div className="stats-shell">
    <section className="stats-intro">
      <div>
        <p className="stats-intro__eyebrow">Impact Snapshot · Study Year 2024</p>
        <h1>Every data point represents a student or mentor we coached this year.</h1>
        <p>
          Our research lead, Valerie Voytsekhovskaya, surveys mentees and mentors at the end of each cycle.
          These findings inform the curriculum, matching algorithm, and training investments we make for 2025.
        </p>
      </div>
      <div className="stats-intro__grid">
        {highlightMetrics.map((metric) => (
          <article key={metric.label}>
            <span>{metric.label}</span>
            <strong>{metric.value}</strong>
            <p>{metric.detail}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="stats-insights">
      {insights.map((card) => (
        <article key={card.title} className="stats-insights__card">
          <h2>{card.title}</h2>
          <ul>
            {card.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        </article>
      ))}
    </section>

    <section className="stats-section">
      <div className="stats-section__header">
        <h2>Mentee reflections</h2>
        <p>The top four outcomes mentees reported after completing our curriculum.</p>
      </div>
        <div className="stats-section__grid">
          {menteeStats.map((stat) => (
            <article key={stat.detail} className="stats-value-card">
              <strong>{stat.value}</strong>
              <p>{stat.detail}</p>
            </article>
          ))}
        </div>
    </section>

    <section className="stats-footnote">
      <p>
        These insights come from LTF’s annual longitudinal study. Questions? Contact{' '}
        <a href="mailto:staff@projectlevelthefield.com">staff@projectlevelthefield.com</a>.
      </p>
    </section>
  </div>
);

export default Numbers;
